module.exports = __webpack_public_path__ + "static/media/chipLay1.48e25e4c.mp3";